var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'vertical-split',
    'flex',
    'flex-col',
    'lg:flex-row',
    _vm.handleScreenSize ]},[_c('PurpleHexContainer',{staticClass:"max-w-1/2 w-full",staticStyle:{"min-height":"128px"}},[_c('div',{staticClass:"relative block lg:flex items-center justify-center min-h-full"},[(_vm.noLogo)?_c('BambeeLogo',{staticClass:"block mx-auto mb-6 mt-6 lg:mb-0 lg:mt-0 lg:absolute lg:top-6 lg:left-16"}):_vm._e(),_vm._v(" "),_vm._t("left")],2)]),_vm._v(" "),_c('div',{staticClass:"bg-white max-w-1/2 w-full h-full lg:min-h-full overflow-y-auto lg:py-10"},[_vm._t("right")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }